<template>
  <div class="vx-row mb-2">
    <div class="vx-col w-full">
      <vs-textarea
        v-show="!showTerms"
        class="w-full"
        v-validate="structure.validation"
        :label="fieldLabel"
        v-model="localVal"
        name="field"
        :counter="structure.max"
        :height="structure.height"
        @keyup="changeHandler"
        :maxLength="structure.max"
      />


      <span class="text-danger text-sm" v-show="errors.has('field')">{{
        errors.first("field")
      }}</span>
    </div>
  </div>
</template>
<script>
import { sidebarMixin } from "../sidebarMixin";
import { bus } from "../../../main";
export default {
  mixins: [sidebarMixin],
  props: {
    index: String,
    structure: {
      type: Object,
      default: () => {},
      required: true,
    },
    value: String,
    validation: "",
  },
  data() {
    return {
      localVal: "",
      name: "",
      terms: "",
      showTerms: false
    };
  },

  methods: {
    changeHandler() {
      // this.$emit("error", this.errors.errors);
      this.$validator.validateAll().then((result) => {
        this.$emit("error", { index: this.index, value: result });
      });
    },
  },
  mounted() {
    const self = this;
    bus.$on("contractTermChange", function (payLoad) {

      if (self.index == "contractTerms") {
        self.localVal = payLoad.terms;
      }

    });
  },
  created() {
    this.showTerms= false;
    if(this.index == "contractTerms"){
      this.showTerms = true;
    }


    //we emit the default value because if user does not touch it won't be captured in the array
    this.$emit("input", { index: this.index, value: this.value });

    this.localVal = this.value;

    if (this.structure.required == "yes") {
      if (this.localVal == "" || this.localVal == undefined) {
        this.$emit("error", { index: this.index, value: false });
      } else {
        this.$emit("error", { index: this.index, value: true });
      }
    } else {
      this.$emit("error", { index: this.index, value: true });
    }

    this.$watch("localVal", (value) => {
      this.$emit("input", { index: this.index, value: value });
    });
  },
};
</script>
